import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/store/authSlice';
import customerReducer from '../features/customer/store/customerSlice';
import bookingReducer from '../features/booking/store/bookingSlice';
import serviceReducer from '../features/service/store/serviceSlice';
import notificationReducer from '../features/notification/store/notificationSlice';

/**
 * Redux Store Configuration
 */
const store = configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    booking: bookingReducer,
    service: serviceReducer,
    notification: notificationReducer,
    // Add more reducers as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;


